import $ from "/home/forge/www.missie3.nl/wp-content/plugins/wp-soup-framework/node_modules/jquery";

$(document).ready(function () {
  //
});
function equalheight(container) {
  var currentTallest = 0,
    currentRowStart = 0,
    rowDivs = new Array(),
    $el,
    topPosition = 0;
  $(container).each(function () {
    $el = $(this);
    $($el).height("auto");
    topPosition = $el.position().top;

    if (currentRowStart != topPosition) {
      for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPosition;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest =
        currentTallest < $el.height() ? $el.height() : currentTallest;
    }
    for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}

$(document).ready(function () {
  let screenSize = $(window).width();
  const title = $(".grid-project-title");
  const excerpt = $(".grid-project-excerpt");
  if (screenSize > 500) {
    equalheight(title);
    equalheight(excerpt);
  }
  window.dispatchEvent(new Event("resize"));
});

$(window).resize(function () {
  let screenSize = $(window).width();
  const title = $(".grid-project-title");
  const excerpt = $(".grid-project-excerpt");
  if (screenSize > 500) {
    equalheight(title);
    equalheight(excerpt);
  }
});
